export default "__VITE_ASSET__CPiMhnJO__"